import { RHFSelect, Spacing } from "@app/components";
import { Strings } from "@app/constants";
import { Divider, MenuItem, Stack, Typography } from "@mui/material";
import {
  Brands,
  Model,
  TransmissionType,
  EngineType,
  CarTraveled,
} from "../fixtures";
import {
  insuranceAvailable,
  insuranceType,
  usageType,
  AccidentHistory,
  CarCondition,
  Variant,
} from "../types";
import dayjs from "dayjs";

export const renderDropDown = (
  field: string,
  apiData?: any[],
  apiLoading?: boolean,
  customName?: string // ✅ added this
) => {
  let fieldName: string = "";
  let placeHolderName: string = "";
  let dropDownData: any[] = [];

  const getPast15Years = () => {
    const currentYear = dayjs().year();
    return Array.from({ length: 16 }, (_, i) => ({
      year: currentYear - i,
      id: currentYear - i,
    }));
  };

  switch (field) {
    case Strings.product.brand:
      fieldName = "brandId";
      placeHolderName = "Brand";
      dropDownData = Brands;
      break;
    case Strings.product.manufacturingYear:
      fieldName = "manufacturingYear";
      placeHolderName = "Manufacturing Year";
      dropDownData = getPast15Years();
      break;
    case Strings.product.model:
      fieldName = "modelId";
      placeHolderName = "Model";
      dropDownData = Model;
      break;
    case Strings.product.transmissionType:
      fieldName = "transmission";
      placeHolderName = "Transmission Type";
      dropDownData = TransmissionType;
      break;
    case Strings.product.engineType:
      fieldName = "engineType";
      placeHolderName = "Engine Type";
      dropDownData = EngineType;
      break;
    case Strings.product.carTraveled:
      fieldName = "driven";
      placeHolderName = "Car Traveled";
      dropDownData = CarTraveled;
      break;
    case Strings.product.variant:
      fieldName = "variant";
      placeHolderName = "Variant";
      dropDownData = Variant;
      break;
    case Strings.product.insuranceAvailable:
      fieldName = "insuranceAvailable";
      placeHolderName = "Insurance Available";
      dropDownData = insuranceAvailable;
      break;
    case Strings.product.insuranceType:
      fieldName = "insuranceType";
      placeHolderName = "Insurance Type";
      dropDownData = insuranceType;
      break;
    case Strings.product.anyClaimsMade:
      fieldName = "anyClaimsMade";
      placeHolderName = "Any Claims Made";
      dropDownData = insuranceAvailable;
      break;
    case Strings.product.usageType:
      fieldName = "usageType";
      placeHolderName = "Usage Type";
      dropDownData = usageType;
      break;
    case Strings.product.rcAvailable:
      fieldName = "rcAvailable";
      placeHolderName = "RC Available";
      dropDownData = insuranceAvailable;
      break;
    case Strings.product.loanHyonthecation:
      fieldName = "loanHyonthecation";
      placeHolderName = "Loan/Hyonthecation";
      dropDownData = insuranceAvailable;
      break;
    case Strings.product.accidentHistory:
      fieldName = "accidentHistory";
      placeHolderName = "Accident History";
      dropDownData = AccidentHistory;
      break;
    case Strings.product.fullServiceRecord:
      fieldName = "fullServiceRecord";
      placeHolderName = "Full Service Record";
      dropDownData = insuranceAvailable;
      break;
    case Strings.product.carCondition:
      fieldName = "carCondition";
      placeHolderName = "Car Condition";
      dropDownData = CarCondition;
      break;
    default:
      fieldName = "";
      placeHolderName = "";
      dropDownData = [];
      break;
  }

  const dataToRender = apiData || dropDownData;
  const isLoading = apiLoading || false;

  return (
    <Stack
      sx={{
        width: { xs: "100%", md: "48%" },
        mb: 2,
        mt: { xs: 2, md: 0 },
      }}
    >
      <Typography
        sx={{
          mb: 1,
          fontWeight: 600,
          fontFamily: "Work Sans",
          color: "#222",
        }}
      >
        {field}
      </Typography>

      <RHFSelect
        name={customName || fieldName} // ✅ supports custom 4th argument
        variant="outlined"
        placeholder={placeHolderName}
        disabled={isLoading}
      >
        {isLoading && (
          <MenuItem value="" disabled>
            Loading...
          </MenuItem>
        )}

        {!isLoading &&
          Array.isArray(dataToRender) &&
          dataToRender.length > 0 &&
          dataToRender.map((item) => {
            const valueText =
              item.name || item.brand || item.year || item.type || item.label;
            const value =
              ["brandId", "modelId", "id"].includes(fieldName)
                ? item.id
                : valueText;

            return (
              <MenuItem key={item.id || item.value || valueText} value={value}>
                {valueText}
              </MenuItem>
            );
          })}
      </RHFSelect>
    </Stack>
  );
};

export const renderFieldsHeading = (field: string) => (
  <>
    <Spacing top={10} />
    <Typography variant="subtitle1">{field}</Typography>
    <Divider sx={{ my: 1.5 }} />
  </>
);
